import React from "react";
import { Link } from "react-router-dom";
import Moment from "react-moment";
import { TruncateTxn } from "../../../shared/utils";
import { List, Tooltip } from "antd";
import { RobotOutlined } from "@ant-design/icons";
import "./BlocksItem.scss";

export default function BlocksItem({ item }) {
  return (
    <List.Item key={item.id} className="BlocksItem">
      <List.Item.Meta
        title={
          <Link to={`/block/${item.block}`} className="BlocksItem__link">
            <RobotOutlined /> #{item.block}
          </Link>
        }
        description={
          <div className="BlocksItem__description">
            <Tooltip
              placement="bottomLeft"
              title={
                <div className="BlocksItem__description__tip">
                  {item.txns.map((txn, index) => (
                    <div key={index}>
                      <TruncateTxn children={txn} address={true} />
                    </div>
                  ))}
                </div>
              }
            >
              <div className="BlocksItem__description__content">
                {item.txns.length} transactions
              </div>
            </Tooltip>
          </div>
        }
      />
      <div className="BlocksItem__content">
        {item.miner ? (
          <div>
            <span className="BlocksItem__content__label">Produced by: </span>
            <Link to={`/account/${item.miner.address}`}>
              {item.miner.miner}
            </Link>
          </div>
        ) : null}
        <div>
          <Moment fromNow interval={100}>
            {item.date}
          </Moment>
        </div>
      </div>
    </List.Item>
  );
}
